module.exports = __webpack_public_path__ + "img/wind.56e49cd3.svg";